import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

// Actions
import { openPrioritiesDrawer } from './actions';

class Priority extends Component {

  render(){
    const { classes, theme, location, data } = this.props;

    let priority = data.DSCID;

    console.log("priority data is"+JSON.stringify(data));

    if (priority == 1) {
      return(
        <div className={classes.container}>
          <Button className={classes.whiteText} onClick={() => this.props.openPrioritiesDrawer(data)}>
            DATING
          </Button>
        </div>
      );
    } else if (priority == 2){
      return(
        <div className={classes.container}>
          <Button className={classes.priorityLightGreen} onClick={() => this.props.openPrioritiesDrawer(data)}>
            PURSUING
          </Button>
        </div>
      );
    } else if (priority == 3) {
      // Good Colour
      return(
        <div className={classes.container}>
          <Button className={classes.priorityGreen} onClick={() => this.props.openPrioritiesDrawer(data)}>
            WAITING
          </Button>
        </div>
      );
    } else if (priority == 4) {
      return(
        <div className={classes.container}>
          <Button className={classes.priorityRed} onClick={() => this.props.openPrioritiesDrawer(data)}>
            GAVE UP
          </Button>
        </div>
      );
    } else if (priority == 5) {
      return(
        <div className={classes.container}>
          <Button className={classes.priorityBlack} onClick={() => this.props.openPrioritiesDrawer(data)}>
            OMMITTED
          </Button>
        </div>
      );
    } else {
      return(
        <div className={classes.container}>
          <Button className={classes.priorityWhite} onClick={() => this.props.openPrioritiesDrawer(data)}>
            NONE
          </Button>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        counter: state.counter,
        router: state.router,
        priority: state.dashboard.priority,
        customer_number: state.customer.number,
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        openPrioritiesDrawer: openPrioritiesDrawer,
    }, dispatch);
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps,matchDispatchToProps)(Priority)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/ActionsDrawer/components/CandidateItem/components/Priority/index.js